import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {AisCommonModule, AuthInterceptorService} from 'ais-common';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import {DotaznikyComponent} from './dotazniky/dotazniky.component';
import {BodyComponent} from './body/body.component';
import {MessagesComponent} from './messages/messages.component';
import {PoplatkyComponent} from './poplatky/poplatky.component';
import {JobMarketComponent} from './job-market/job-market.component';
import {InfoComponent} from './info/info.component';
import {DiskusiaComponent} from './diskusia/diskusia.component';
import {AplikacieComponent} from './aplikacie/aplikacie.component';
import {StudiumComponent} from './studium/studium.component';
import {SubMessagesComponent} from './sub-messages/sub-messages.component';
import {ZapisneListyComponent} from './zapisne-listy/zapisne-listy.component';
import {StudiumItemComponent} from './studium-item/studium-item.component';
import {SlavnostiComponent} from './slavnosti/slavnosti.component';
import {StatneSkuskyComponent} from './statne-skusky/statne-skusky.component';
import {MessageItemComponent} from './message-item/message-item.component';
import {JobItemComponent} from './job-item/job-item.component';
import {PoplatokItemComponent} from './poplatok-item/poplatok-item.component';
import {FlashMessageListComponent} from './flash-message-list/flash-message-list.component';
import {FlashMessageComponent} from './flash-message/flash-message.component';
import {ZalozkyComponent} from './zalozky/zalozky.component';
import {ZalozkaComponent} from './zalozka/zalozka.component';
import {ZalozkaObsahComponent} from './zalozka-obsah/zalozka-obsah.component';
import {ZapisnyListComponent} from './zapisny-list/zapisny-list.component';

import {registerLocaleData} from '@angular/common';
import {StatnaSkuskaComponent} from './statna-sluska/statna-skuska.component';
import {ZaverecnePraceComponent} from './zaverecne-prace/zaverecne-prace.component';
import {ZaverecnaPracaComponent} from './zaverecna-praca/zaverecna-praca.component';
import {SlavnostComponent} from './slavnost/slavnost.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {RozvrhComponent} from './rozvrh/rozvrh.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatBadgeModule} from '@angular/material/badge';

import localeSk from '@angular/common/locales/sk';
import {MatChipsModule} from '@angular/material/chips';
import { BannerComponent } from './banner/banner.component';
import { HarmonogramRokaComponent } from './harmonogram-roka/harmonogram-roka.component';
import {MatCardModule} from '@angular/material/card';
import { MobileButtonBarComponent } from './mobile-button-bar/mobile-button-bar.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {HodnotenieDetailComponent} from './hodnotenie-detail/hodnotenie-detail.component';
import {TerminDetailComponent} from './termin-detail/termin-detail.component';

import {MatSnackBarModule} from '@angular/material/snack-bar';
import {A11yModule} from '@angular/cdk/a11y';
import { NastenkaDetailComponent } from './nastenka-detail/nastenka-detail.component';
import { DialogHeaderStudentComponent } from './dialog-header-student/dialog-header-student.component';
import {PodporaComponent} from './podpora/podpora.component';
import {ReklamaComponent} from './reklama/reklama.component';

registerLocaleData(localeSk);

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    DotaznikyComponent,
    BodyComponent,
    MessagesComponent,
    PoplatkyComponent,
    JobMarketComponent,
    InfoComponent,
    DiskusiaComponent,
    AplikacieComponent,
    StudiumComponent,
    SubMessagesComponent,
    ZapisneListyComponent,
    StudiumItemComponent,
    SlavnostiComponent,
    StatneSkuskyComponent,
    MessageItemComponent,
    JobItemComponent,
    PoplatokItemComponent,
    FlashMessageListComponent,
    FlashMessageComponent,
    ZalozkyComponent,
    ZalozkaComponent,
    ZalozkaObsahComponent,
    ZapisnyListComponent,
    StatnaSkuskaComponent,
    ZaverecnePraceComponent,
    ZaverecnaPracaComponent,
    SlavnostComponent,
    RozvrhComponent,
    BannerComponent,
    HarmonogramRokaComponent,
    MobileButtonBarComponent,
    HodnotenieDetailComponent,
    TerminDetailComponent,
    NastenkaDetailComponent,
    DialogHeaderStudentComponent
  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        AisCommonModule,
        MatDialogModule,
        MatRadioModule,
        MatIconModule,
        MatCheckboxModule,
        BrowserAnimationsModule,
        MatProgressSpinnerModule,
        MatMenuModule,
        MatButtonModule,
        MatChipsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
            defaultLanguage: 'sk'
        }),
        MatExpansionModule,
        MatBadgeModule,
        MatCardModule,
        MatTooltipModule,
        MatSnackBarModule,
        A11yModule,
        PodporaComponent,
        ReklamaComponent,
    ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    }
    // , { provide: LOCALE_ID, useValue: 'sk' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
